import {app,} from "./support"
import {createUserWithEmailAndPassword, getAuth,sendPasswordResetEmail,signInWithEmailAndPassword,signOut} from "firebase/auth"
import { onAuthStateChanged } from "firebase/auth"
const _auth=getAuth(app)
export const currentUser = _auth.currentUser
function auth(){

    return {
        signInWithEmailAndPassword:(...args:any)=>{
            return signInWithEmailAndPassword(_auth,args[0],args[1])
        },
        signOut:()=>{
            return signOut(_auth)
        },
        createUserWithEmailAndPassword:(...args:any)=>{
            return createUserWithEmailAndPassword(_auth,args[0],args[1])
        },
        sendPasswordResetEmail:(...args:any)=>{
            console.log(args[0])
            return sendPasswordResetEmail(_auth,args[0])
        },
        getCurrentUser: function() {
            return new Promise((resolve, reject) => {
                const unsubscribe = onAuthStateChanged(_auth, user => {
                    unsubscribe();
                    resolve(user);
                }, reject);
            });
        }
    }
}


export default auth